import { render, staticRenderFns } from "./PolarAreaChart.vue?vue&type=template&id=351b8d86&"
import script from "./PolarAreaChart.vue?vue&type=script&lang=ts&"
export * from "./PolarAreaChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports